import { GET_NDA_AGREEMENT, GET_NDA_AGREEMENT_FAILED, GET_NDA_AGREEMENT_SUCCESS, SEND_AGREEMENT_MAIL, SEND_AGREEMENT_MAIL_FAILED, SEND_AGREEMENT_MAIL_SUCCESS, UPLOAD_AGREEMENT, UPLOAD_AGREEMENT_FAILED, UPLOAD_AGREEMENT_SUCCESS } from "./Constants"

export const uploadNdaAgreement = (file) =>{
    return{
        type: UPLOAD_AGREEMENT,
        payload: file
    }
}

export const uploadNdaAgreementSuccess = (payload) =>({
    type: UPLOAD_AGREEMENT_SUCCESS,
    payload
})

export const uploadNdaAgreementFailed = (payload) => ({
    type: UPLOAD_AGREEMENT_FAILED,
    payload
})

export const getNdaAgreement = () =>{
    return{
        type: GET_NDA_AGREEMENT
    }
}

export const getNdaAgreementSuccess = (payload) =>({
    type: GET_NDA_AGREEMENT_SUCCESS,
    payload
})

export const getNdaAgreementFailed = (payload) =>({
    type: GET_NDA_AGREEMENT_FAILED,
    payload
})

export const sendAgreementMail = () =>({
    type: SEND_AGREEMENT_MAIL
})

export const sendAgreementMailSuccess = (payload) =>({
    type: SEND_AGREEMENT_MAIL_SUCCESS,
    payload
})

export const sendAgreementMailFailed = (payload) =>({
    type: SEND_AGREEMENT_MAIL_FAILED,
    payload
})